import React from "react";
import { useParams, useSearchParams } from "react-router-dom";
import ViewForm from "./ViewForm/ViewForm";
import { API_URLS } from "../../api/apiUrls";

const ViewDynamicForm = () => {
  const { formId } = useParams();
  const [searchParams] = useSearchParams();
  const clientId = searchParams.get("clientId");

  return (
    <div className="h-full px-5 pb-5 bg-white ">
      <ViewForm
        formId={formId}
        clientId={clientId}
        sectionurl={API_URLS.CUSTOMFORM_SECTIONS}
        subsectionurl={API_URLS.CUSTOMFORM_SUBSECTIONS}
        questionurl={API_URLS.CUSTOMFORM_QUESTIONS}
      />
    </div>
  );
};

export default ViewDynamicForm;
